import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {
  CATEGORIAS_WEB,
  getAllPromociones,
  getOnePromotion,
  SERVICIOS_POR_DESCUENTO,
  UPDATE_ADD_PROMOTION
} from '../../../graphql/graphql.queris';
import { Apollo } from 'apollo-angular';
import { NgForOf, NgIf } from "@angular/common";
import { DomSanitizer } from "@angular/platform-browser";
import { RestService } from "../../../services/rest.services.service";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import {capturarFile, closeModal, convertirPrimeraLetraMayuscula, validateSizeFile} from "../../../utils/utilities";
import { environment } from "../../../../environments/environment";
import { RouterLink } from "@angular/router";
import { AuthService } from "../../../auth/auth.service";
import { ServiceNotificationService } from "../../../services/service-notification.service";
import { NotificationsComponent } from "../../../notifications/notifications.component";
import moment from "moment";
import { BreadcrumbMktComponent } from "../breadcrumb-mkt/breadcrumb-mkt.component";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable, MatTableDataSource
} from "@angular/material/table";
import { MatButton } from "@angular/material/button";
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: 'app-promociones-mkt-sam',
  standalone: true,
  imports: [
    NgForOf,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    RouterLink,
    NotificationsComponent,
    BreadcrumbMktComponent,
    MatTable,
    MatHeaderCell,
    MatColumnDef,
    MatCell,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    MatButton,
    MatSort,
    MatSortHeader,
    MatPaginator
  ],
  templateUrl: './promociones-mkt-sam.component.html',
  styleUrls: ['./promociones-mkt-sam.component.css'],
})
export class PromocionesMktSamComponent implements OnInit, AfterViewInit {
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild('importPromocion') importPromocion!: ElementRef;
  @ViewChild('inputImage') inputImage!: ElementRef;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  promotions: any[] = [];
  public archivos: any = [];
  preview: string | ArrayBuffer | null | undefined;
  isLoading: Boolean = false;
  servicios: { serv_nombre: string }[] = [];
  detailsText: string = '';
  valuePromotion: number | undefined;
  codePromotion: number | undefined;
  urlImage: string = '';
  loading = true;
  descripcion: string = '';
  formPromocion: FormGroup = new FormGroup({});
  name = '';
  tipoPromocion: string = '';
  descripcionPromocion: any[] = [];
  title = 'Promociones Sam';
  categorias: any[] = [];
  _id: string = '';
  route = '/dashboardmkt/promocionesSam';

  constructor(
    private apollo: Apollo,
    private sanitizer: DomSanitizer,
    private restService: RestService,
    private fb: FormBuilder,
    private authService: AuthService,
    private serviceNotifications: ServiceNotificationService,
  ) {
  }

  displayedColumns: string[] = [
    'position',
    'nombre_descuento',
    'valor_desc',
    'tipo_desc',
    'estado',
    'acciones'
  ];

  ngOnInit() {
    this.getPromociones();
    this.getCategorias();
    this.dataSource.paginator = this.paginator;
    setTimeout(() => {
      const prevButton = document.querySelector('.mat-mdc-paginator-navigation-previous');
      const nextButton = document.querySelector('.mat-mdc-paginator-navigation-next');

      if (prevButton) {
        prevButton.removeAttribute('aria-label');
        prevButton.removeAttribute('ng-reflect-message');
      }

      if (nextButton) {
        nextButton.removeAttribute('aria-label');
        nextButton.removeAttribute('ng-reflect-message');
      }
    }, 0);

    this.formPromocion = this.fb.group({
      _id: ['', [Validators.required] ],
      nombre: ['', [Validators.required]],
      tipoPromocion: ['', [Validators.required]],
      servicios: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      fechaExpiracion: ['2050-12-12', [Validators.required]],
      statusPromocion: [true, [Validators.required]],
      disclaimer: ['Aplica a particulares', [Validators.required]],
      codPromocionSam: ['', [Validators.required]],
      precio: [''],
      imagenPromocion: [''],
      createdAt: moment(new Date()).toISOString()
    });

    this.formPromocion.get('statusPromocion')?.valueChanges.subscribe(value => {
      const booleanValue = value === 'true';
      if (this.formPromocion.get('statusPromocion')?.value !== booleanValue) {
        this.formPromocion.patchValue({statusPromocion: booleanValue}, {emitEvent: false});
      }
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }


  getAllDataPromotion(codDescuentos: number) {
    this.isLoading = false;
    this.authService.isTokenExpired();
    this.getServiciosPorPromocion(codDescuentos);
    this.getOnePromocion(codDescuentos);
    this.codePromotion = codDescuentos;
    this.formPromocion.patchValue({
      codPromocionSam: codDescuentos
    })
  }

  onSubmit(): void {
    if (this.formPromocion.valid) {
      console.log('Form valid');
    } else {
      console.log('Form not valid');
    }
  }

  getOnePromocion(cod_descuentos: number) {
    this.authService.isTokenExpired();
    this.apollo
      .watchQuery({
        query: getOnePromotion,
        variables: { cod_descuentos },
        context: {
          headers: {
            Authorization: `Bearer ${this.authService.getToken()}`
          }
        }
      })
      .valueChanges.subscribe((result: any) => {
        this.name = convertirPrimeraLetraMayuscula(result.data.getOnePromotion.nombre_descuento);
        this.tipoPromocion = convertirPrimeraLetraMayuscula(result.data.getOnePromotion.tipo_desc);
        this.valuePromotion = result.data.getOnePromotion.valor_desc;
        this.formPromocion.patchValue({
          precio: this.valuePromotion,
          nombre: this.name,
          tipoPromocion: this.tipoPromocion
        })
      });
  }

  getPromociones() {
    this.authService.isTokenExpired();
    this.apollo
      .watchQuery({
        query: getAllPromociones,
        context: {
          headers: {
            Authorization: `Bearer ${this.authService.getToken()}`
          }
        }
      })
      .valueChanges.subscribe((result: any) => {
        this.promotions = result.data.getAllPromociones;
        this.promotions = this.promotions.filter((promotion: any) => promotion.tipo_desc === 'PAQUETE');
        this.dataSource.data = this.promotions;
      });
  }

  getCategorias() {
    this.authService.isTokenExpired();
    this.apollo.watchQuery({
      query: CATEGORIAS_WEB,
      context: {
        headers: {
          Authorization: `Bearer ${this.authService.getToken()}`
        }
      }
    }).valueChanges.subscribe((result: any) => {
      this.categorias = result.data.getAllDataWebPrivate;
    });
  }

  getServiciosPorPromocion(codDescuentos: number) {
    this.authService.isTokenExpired();
    this.apollo.query({
      query: SERVICIOS_POR_DESCUENTO,
      variables: { codDescuentos },
      context: {
        headers: {
          Authorization: `Bearer ${this.authService.getToken()}`
        }
      }
    })
      .subscribe(
        (result: any) => {
          if (result.data && result.data.serviciosPorDescuento) {
            this.servicios = result.data.serviciosPorDescuento.map((servicio: any) => convertirPrimeraLetraMayuscula(servicio.serv_nombre));
            const detailsText = this.servicios.join('\n');
            this.formPromocion.patchValue({
              servicios: convertirPrimeraLetraMayuscula(detailsText)
            });
          } else {
            this.mostrarToast('No se encontraron servicios para la promoción', false);
          }
        },
        (error) => {
          this.mostrarToast('Ha ocurrido un error al recuperar los datos de la promoción', false);
        }
      );
  }

  capturarArchivo(event: Event): void {
    const input =  event.target as HTMLInputElement;
    let validate;
    if (input && input.files) {
      validate = validateSizeFile(input.files[0].size);
    }
    if (!validate) {
      this.mostrarToast('El tamaño de la imagen no puede ser mayor a 5MB', false);
      this.preview = '';
      this.inputImage.nativeElement.value = '';
      return;
    }
    capturarFile(event, this.sanitizer, this.archivos, (preview) => this.preview = preview);
  }

  sendAllData() {
    if (!this.formPromocion.valid) {
      this.mostrarToast('Asegurate que los datos el formulario esté correctos', false);
    } else {
      try {
        this.isLoading = true;
        this.authService.isTokenExpired();
        const datosPromocion = new FormData();
        this.archivos.forEach((archivo: any) => {
          datosPromocion.append('file', archivo);
        })
        if (this.archivos.length === 0) {
          this.loading = false;
          this.mostrarToast('No se ha seleccionado una imagen', false);
          closeModal(this.importPromocion);
        } else {
          this.restService.post({ url: environment.apiUploadImage, body: datosPromocion })
            .subscribe((res: any) => {
              this.urlImage = res[0].path;
              this.formPromocion.patchValue({
                imagenPromocion: this.urlImage
              });
              this.mostrarToast('Imagen subida correctamente', true);
              this.funcionCreatePromocion(this.formPromocion.value._id, this.formPromocion.value);
            });
        }
      } catch (e) {
        console.error(e);
      }
    }
  }

  funcionCreatePromocion(id: string, input: any) {
    this.apollo.mutate({
      mutation: UPDATE_ADD_PROMOTION,
      variables: {
        id: id,
        promotion: input
      },
      context: {
        headers: {
          Authorization: `Bearer ${this.authService.getToken()}`
        }
      }
    }).subscribe((result: any) => {
      this.formPromocion.reset();
      this.preview = '';
      this.isLoading = false;
      this.mostrarToast('Promoción importada correctamente', true);
      this.formPromocion.patchValue({ fechaExpiracion: '2050-12-12', statusPromocion: true });
      this.inputImage.nativeElement.value = '';
      this.archivos = [];
      closeModal(this.importPromocion);
    }, (error) => {
      this.mostrarToast('Error al crear la promoción', false);
    });
  }

  protected readonly convertirPrimeraLetraMayuscula = convertirPrimeraLetraMayuscula;

  mostrarToast(message: string, type: boolean) {
    this.serviceNotifications.recibeNotificacion.emit({
      mensaje: message,
      tipo: type
    })
  }
}
